export default __webpack_public_path__ + "static/media/chip.b2f2cef5.svg";